const table_filter = {
	pagination: {
		from: "of",
		more_than: "more than",
		rows_per_page: "Rows per page",
	},
	table_row_empty: "No results found...",
	toolbar: {
		reset: "Reset",
		search: "Search in table",
	},
};

export default table_filter;
